import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  FormControl,
  InputLabel,
  FormHelperText,
  Select,
  MenuItem,
  ListItemText, Checkbox
} from '@material-ui/core'
import { ButtonLoader } from '../components/Loader/ButtonLoader'

const FormSelectField = ({ formActions, classes, name, labelKey, list, required, row, type, locale, setFilter, displayEmpty = false, withKey, withKeyParenthesis, withKeyNext, returnedObj, hint, small, large, disabled, multiple, loading, largeHeight }) => {
  const intl = useIntl()
  const [exactList, setExactList] = React.useState([])

  const documentTypeVersion = [
    // { key: '0.9', name: intl.formatMessage({ id: 'documentTypeVersion.0.9' }) },
    { key: '1.0', name: intl.formatMessage({ id: 'documentTypeVersion.1.0' }) }
  ]

  const itemTypes = [
    { key: 'GS1', name: intl.formatMessage({ id: 'itemTypes.GS1' }) },
    { key: 'EGS', name: intl.formatMessage({ id: 'itemTypes.EGS' }) }
  ]

  const InvoiceCancelReasons = [
    {
      key: intl.formatMessage({ id: 'InvoiceCancelReasons.WrongBuyerDetails' }),
      name: intl.formatMessage({ id: 'InvoiceCancelReasons.WrongBuyerDetails' })
    },
    {
      key: intl.formatMessage({ id: 'InvoiceCancelReasons.WrongInvoiceDetails' }),
      name: intl.formatMessage({ id: 'InvoiceCancelReasons.WrongInvoiceDetails' })
    },
    {
      key: 'otherReason',
      name: intl.formatMessage({ id: 'InvoiceCancelReasons.Other' })
    }
  ]
  const getExactList = () => {
    if (!!type) {
      switch (type) {
        case 'documentTypeVersion':
          setExactList(documentTypeVersion)
          break
        case 'itemType':
          setExactList(itemTypes)
          break
        case 'status':
          setExactList(documentTypeVersion)
          break
        case 'invoiceCancel':
          setExactList(InvoiceCancelReasons)
          break
        default:
          setExactList(list)
          break
      }
    } else {
      setExactList(list)
    }
  }
  React.useEffect(() => {
      getExactList()
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  React.useEffect(() => {
      if (!!list) {
        getExactList()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [list])

  const handleSelectChange = (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    let exactValue = ''
    if (!!multiple) {
      if (!!event.target.value) {
        if (event.target.value?.length && event.target.value.includes('selectAll')) {
          if (formActions.values[name]?.length === exactList?.length) {
            formActions.setFieldValue(name, [])
            exactValue = []
          } else {
            formActions.setFieldValue(name, exactList?.length ? exactList.map(({ key }) => key) : [])
            exactValue = exactList?.length ? exactList.map(({ key }) => key) : []
          }
        } else {
          formActions.setFieldValue(name, event.target.value)
          exactValue = event.target.value
        }
      } else {
        formActions.setFieldValue(name, [])
        exactValue = []
      }
    } else {
      formActions.setFieldValue(name, event.target.value.toString())
      exactValue = event.target.value.toString()
    }


    if (!!setFilter) {
      setFilter(exactValue)
    }
    if (!!returnedObj) {
      let obj = !!multiple ? exactList.filter(item => exactValue.includes(item?.key)) : exactList.filter(item => item?.key?.toString() === event.target.value.toString())
      if (!!obj?.length) {
        returnedObj(!!multiple ? obj : obj[0])
      } else {
        returnedObj(!!multiple ? [] : {})
      }
    }
  }
  let newClasses = [
    !!row ? classes.FormRow : '',
    !!small ? classes.FormSmall : '',
    !!large ? classes.FormLarge : '',
    !!largeHeight ? classes.FormLargeHeight : ''
  ].filter(item => !!item).join(' ')

  let extraAttrs = {}
  if (!!multiple) {
    extraAttrs = {
      renderValue: (selected) => (
        <div className={classes.selectValueContent}>
          {!!selected?.length ? selected.map((itemKey) => {
            let items = !!itemKey ? exactList.filter((item) => item.key.toString() === itemKey.toString()) : []
            return items?.length && (!!locale ? items[0][`name_${locale}`] || items[0]['name_en'] : items[0].name)
          }).join(', ') : <FormattedMessage id={labelKey}/>}
        </div>)
    }
  }

  return (
    <div className={classes.FormItem + ` ${newClasses}`}>
      <InputLabel id={name + '-label'} htmlFor={name}><FormattedMessage id={labelKey}/>{!!required &&
      <span className={'required'}>*</span>}:</InputLabel>
      <FormControl variant="outlined" className={classes.FormItemSelect}>
        {!!loading && <ButtonLoader loading={true} />}
        <Select
          fullWidth
          displayEmpty={!!displayEmpty}
          multiple={!!multiple}
          disabled={!!disabled || !!loading}
          labelId={name + '-label'}
          id={name}
          name={name}
          margin={'dense'}
          variant='outlined'
          MenuProps={{ disableScrollLock: true }}
          value={!!exactList?.length ? formActions.values[name] : (!!multiple ? [] : '')}
          // label={intl.formatMessage({ id: 'Fields.Labels.Role' })}
          onChange={handleSelectChange}
          onBlur={formActions.handleBlur}
          error={formActions.errors[name] && formActions.touched[name] !== undefined}
          {...extraAttrs}
        >
          {!!displayEmpty &&
          <MenuItem value={!!multiple ? [] : ''} disabled={!!multiple}><FormattedMessage id={labelKey}/></MenuItem>}
          {!!multiple && <MenuItem value={'selectAll'}>
            <Checkbox color={'secondary'} checked={formActions.values[name]?.length === exactList?.length}/>
            <ListItemText primary={intl.formatMessage({ id: 'Table.List.Table.All' })}/>
          </MenuItem>}
          {!!exactList?.length && exactList.map((item, index) => (
            <MenuItem key={item.key} value={item.key} disabled={item?.disabled || false}>
              {!!multiple && <Checkbox color={'secondary'} checked={formActions.values[name]?.includes(item.key)}/>}
              <div
                className={((!!locale && !!item[`desc_${locale}`]) || !!item.desc) ? classes.SelectItemWithTitle : ''}>
                <span className={'title'}>
                  {!!withKey ? <span><strong>{item.key}</strong> </span>: (!!withKeyParenthesis && <span><strong>({item.key})</strong> </span>)}
                  {!!locale ? item[`name_${locale}`] || item['name_en'] : item.name}
                  {!!withKeyNext && <span> (<strong>{item.key}</strong>)</span>}
                </span>
                {!!locale && !!item[`desc_${locale}`] ?
                  <span className={'description'}>{item[`desc_${locale}`]}</span> : (!!item.desc &&
                    <span className={'description'}>{item.desc}</span>)}
              </div>
            </MenuItem>))}
        </Select>
        {formActions.errors[name] && formActions.touched[name] && (
          <FormHelperText error={true}>{formActions.errors[name]}</FormHelperText>
        )}
        {!!hint && hint}
      </FormControl>
    </div>
  )
}

export default FormSelectField
